/* global window */
export const cssPrefix = 'x-spreadsheet';
export const dpr = window.devicePixelRatio || 1;
export default {
  cssPrefix,
  dpr,
};
